export default __webpack_public_path__ + "static/media/defaultDaoLogo.84bef9e4.svg";